export enum IEmptyStateCTAIcons {
  PEOPLE = 'PEOPLE',
  SEND = 'SEND',
  CHECK = 'CHECK',
  DATE_RANGE = 'DATE_RANGE',
  HISTORY = 'HISTORY',
  NOTIFICATIONS = 'NOTIFICATIONS',
  SEARCH = 'SEARCH',
  EMPTY_HOUSE = 'EMPTY_HOUSE',
}
